module.exports = __webpack_public_path__ + "img/Mifel.a8163e83.png";